import React from "react"
import amexImage from "src/assets/credit-cards/amex.svg"
import discoverImage from "src/assets/credit-cards/discover.svg"
import mastercardImage from "src/assets/credit-cards/mastercard.svg"
import visaImage from "src/assets/credit-cards/visa.svg"

class CreditCardIconGroup extends React.Component {
  render() {
    return (
      <div className="credit-card-icon-group">
        <img className="noselect" alt="visa credit card" src={visaImage} />
        <img
          className="noselect"
          alt="mastercard credit card"
          src={mastercardImage}
        />
        <img className="noselect" alt="amex credit card" src={amexImage} />
        <img
          className="noselect"
          alt="discover credit card"
          src={discoverImage}
        />
      </div>
    )
  }
}

export default CreditCardIconGroup
